export var FALLBACK_DIMENSIONS = {
  height: 100,
  width: 'auto'
};
export var ALIGNMENT_TO_CLASS_MAP = {
  top: 'top-aligned',
  middle: 'middle-aligned',
  bottom: 'bottom-aligned'
};
export var DEFAULT_ALIGNMENT_CLASS = 'middle-aligned';
export var DEFAULT_CONTAINER_CLASS = 'patterned-image-element';
export var DefaultImageSizePatterns = [{
  width: 38,
  height: 60,
  alignment: 'top'
}, {
  width: 29,
  height: 40,
  alignment: 'middle'
}, {
  width: 24,
  height: 80,
  alignment: 'bottom'
}, {
  width: 25,
  height: 33,
  alignment: 'middle'
}];